var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.fetchingApiKey)?_c('loading-page',{attrs:{"full":""}}):_c('api-key-form')}
var staticRenderFns = []

export { render, staticRenderFns }